import React from 'react';
import YourSolutionNavigation from '../Navigation/components/YourSolutionNavigation/YourSolutionNavigation';
import { NavigationDropdownMode } from '../Navigation/Navigation.types';
import YourSolutionCta from '../YourSolutionCta/YourSolutionCta';
import S from './NavigationMobile.styles';
const NavigationMobile = ({ activeId, initial = false, items = [], isPortalHeader = false, onItemClick, onYsButtonClick, onYspButtonClick, }) => {
    // Perf: render only the currently-active level (drill-down) instead of
    // recursively materialising the entire navigation tree into the DOM. The full
    // tree is still passed in as `items`; `activeId` selects which level to show.
    // Deep links remain crawlable via the server-rendered SEO <nav> in Header.ascx.
    const flattened = flatMapRecursive(items, (item) => item.children ?? []);
    const activeItem = flattened.find((item) => item.id === activeId);
    const activeItemChildren = activeItem?.children;
    const activeItemParent = flattened.find((item) => item.children?.find((child) => child.id === activeId));
    const activeItemIsYourSolution = activeItem?.dropdown === NavigationDropdownMode.YourSolution;
    const level = activeItemChildren ?? items;
    return (React.createElement(S.Container, { key: activeItem?.id ?? '0', "data-active-item": activeId, "data-active": activeItem?.id == activeId || initial },
        activeItem && (React.createElement(React.Fragment, null,
            React.createElement(S.BackButton, { onClick: (event) => {
                    event.preventDefault();
                    onItemClick(activeItemParent?.id ?? '0');
                } },
                React.createElement(S.BackArrow, null),
                activeItemParent?.title ? `Back to ${activeItemParent?.title}` : 'Back'),
            React.createElement(S.Title, { href: activeItem.url }, activeItem.title))),
        activeItemIsYourSolution
            ? activeItem?.yourSolutionNavigationProps && (React.createElement(YourSolutionNavigation, { ...activeItem.yourSolutionNavigationProps, onYsButtonClick: onYsButtonClick, onYspButtonClick: onYspButtonClick }))
            : level.map((item) => (React.createElement(S.Item, { "data-use-yoursolution-theme": item.dropdown === NavigationDropdownMode.YourSolution, key: item.id }, (item.children?.length || item.dropdown === NavigationDropdownMode.YourSolution) &&
                !isPortalHeader ? (React.createElement(S.ItemButton, { onClick: (event) => {
                    event.preventDefault();
                    onItemClick(item.id);
                } },
                item.dropdown === NavigationDropdownMode.YourSolution ? (React.createElement(YourSolutionCta, null)) : (item.title),
                React.createElement(S.ItemArrow, null))) : (React.createElement(S.ItemLink, { isBold: item.style === 'bold', href: item.url }, item.title)))))));
};
export default NavigationMobile;
function flatMapRecursive(array, iteratee) {
    let result = [];
    array.forEach((item) => {
        result = result.concat(item);
        if (Array.isArray(iteratee(item))) {
            result = result.concat(flatMapRecursive(iteratee(item), iteratee));
        }
    });
    return result;
}
